// resources/js/stores/score.js
import { defineStore } from 'pinia'

export const useScoreStore = defineStore('score', {
    state: () => ({
        // on récupère le score stocké s’il existe, sinon 20000
        score: parseInt(localStorage.getItem('score') || 0, 10),
        timer: null,
        started: localStorage.getItem('timerStarted') === 'true',
        defaultScore: 20000,
        hintCost: 800,
        solutionCost: 3000,
        wrongAnswerCost: 50,
    }),
    actions: {
        initDefault(score, hintCost, solCost, wrongAnswerCost) {
            this.score = score
            this.defaultScore = score
            this.hintCost = hintCost
            this.solutionCost = solCost
            this.wrongAnswerCost = wrongAnswerCost
            // persister l'état initial
            localStorage.setItem('score', this.score)
            localStorage.setItem('timerStarted', 'true')
        },
        startTimer() {
            //if (this.started) return
            this.started = true
            localStorage.setItem('timerStarted', 'true')
            this.timer = setInterval(() => {
                if (this.score > 0) {
                    this.score--
                    localStorage.setItem('score', this.score)
                }
            }, 1000)
        },
        stopTimer() {
            clearInterval(this.timer)
            this.started = false
            localStorage.removeItem('timerStarted')
        },
        useHint() {
            this.score = Math.max(0, this.score - this.hintCost)
            localStorage.setItem('score', this.score)
        },
        useSolution() {
            this.score = Math.max(0, this.score - this.solutionCost)
            localStorage.setItem('score', this.score)
        },
        wrongAnswer() {
            this.score = Math.max(0, this.score - this.wrongAnswerCost)
            localStorage.setItem('score', this.score)
        }
    }
})
